import { Link as LinkIcon, ExternalLink } from 'lucide-react';
import type { ModelLink } from '@maker-toolchest/shared';
import { Button } from '@/components/Button';
import { LinkBadge } from '@/components/LinkBadge';

interface LinksTableProps {
  links: ModelLink[];
  maxRows?: number;
}

export function LinksTable({ links, maxRows }: LinksTableProps) {
  const displayLinks = maxRows ? links.slice(0, maxRows) : links;

  const handleOpenLink = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  if (links.length === 0) {
    return (
      <div className="text-center py-8 text-foreground-muted">
        <LinkIcon className="h-12 w-12 mx-auto mb-3 opacity-50" />
        <p>No links attached to this model</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead className="bg-background-subtle">
          <tr className="border-b border-border text-left">
            <th className="px-4 py-3 text-xs font-medium text-foreground-muted">Source</th>
            <th className="px-4 py-3 text-xs font-medium text-foreground-muted">Title/URL</th>
            <th className="px-4 py-3 text-xs font-medium text-foreground-muted">Actions</th>
          </tr>
        </thead>
        <tbody className="bg-background">
          {displayLinks.map((link) => (
            <tr key={link.id} className="border-b border-border last:border-0">
              <td className="px-4 py-3">
                <LinkBadge source={link.source} className="inline-flex" />
              </td>
              <td className="px-4 py-3">
                <div className="flex flex-col gap-1">
                  {link.metadataTitle && (
                    <span className="text-sm font-medium text-foreground truncate">
                      {link.metadataTitle}
                    </span>
                  )}
                  <span className="text-xs text-foreground-muted truncate max-w-md">
                    {link.url}
                  </span>
                </div>
              </td>
              <td className="px-4 py-3">
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => handleOpenLink(link.url)}
                  title="Open link"
                >
                  <ExternalLink className="h-4 w-4" />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
